import { useNavigate } from 'react-router-dom';
import { useSupabaseAuth } from '../context/AuthContext';
import Wordmark from '../components/Wordmark';
import Loader from '../components/Loader';

/**
 * Shown when a platform staff action has flipped access off for this user — either
 * profiles.is_deactivated (this account) or organisations.is_suspended (their company).
 * Not itself gated by ProtectedRoute's isBlocked check (that would just bounce right back here) —
 * only requires the person to be signed in.
 */
export default function Blocked() {
  const navigate = useNavigate();
  const { loading, isAuthenticated, isBlocked, blockedReason, signOut } = useSupabaseAuth();

  if (loading) return <Loader text="Checking your session..." />;
  if (!isAuthenticated) {
    navigate('/auth?mode=signin', { replace: true });
    return null;
  }
  if (!isBlocked) {
    navigate('/app', { replace: true });
    return null;
  }

  return (
    <div className="auth-page">
      <div className="auth-shell">
        <div className="auth-head">
          <Wordmark />
        </div>
        <div className="auth-card">
          <h2>Access paused</h2>
          <p>{blockedReason}</p>
          <p style={{ marginTop: 8 }}>
            If you think this is a mistake, contact your programme admin or{' '}
            <a href="mailto:hello@transformax.app">hello@transformax.app</a>.
          </p>
          <button
            type="button"
            className="btn-primary ob-full"
            style={{ marginTop: 16 }}
            onClick={() => signOut()}
          >
            Sign out
          </button>
        </div>
      </div>
    </div>
  );
}
